var angular = require('angular')
var isSameDay = require('date-fns/fp/isSameDay').default

/* based on https://angular-ui.github.io/bootstrap/#datepicker */
var datapickerPopup = require('angular-ui-bootstrap/src/datepickerPopup')

angular.module('ResponsiveDatePickerCmp', [datapickerPopup])
  .component('responsiveDatePicker', {
    template: require('./responsive-date-picker.component.tpl.html'),
    controller: ResponsiveDatePickerCtrl,
    controllerAs: 'vm',
    bindings: {
      divClass: '@',
      labelClass: '@',
      inputClass: '@',
      ngModel: '=',
      onChanged: '&',
      ngModelOptions: '<',
      inputId: '@',
      inputLabel: '@',
      inputRf: '@',
      minDate: '<',
      maxDate: '<',
      ngDisabled: '<',
      isWeekendDisabled: '<',
      disabledDates: '<'
    }
  })

ResponsiveDatePickerCtrl.$inject = ['$timeout']

function ResponsiveDatePickerCtrl ($timeout) {
  var vm = this

  vm.$onInit = function () {
    vm.inputId = vm.inputId || 'date-picker-' + guid()
    vm.ngModelOptions = vm.ngModelOptions || { updateOn: 'change blur' }
    vm.isOpened = false
    vm.dateOptions = {
      showWeeks: false,
      startingDay: 1,
      minDate: vm.minDate,
      maxDate: vm.maxDate,
      formatDay: 'd',
      dateDisabled: dateDisabled
    }
    vm.isMobile = false
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      vm.isMobile = true
    }
  }

  function dateDisabled (data) {
    var weekend = false
    var specificDate = false
    if (vm.isWeekendDisabled) {
      weekend = disableWeekend(data)
    }
    if (angular.isArray(vm.disabledDates)) {
      specificDate = disableDates(data)
    }
    return weekend || specificDate
  }

  function disableWeekend (data) {
    var date = data.date
    var mode = data.mode
    return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6)
  }

  function disableDates (data) {
    var date = data.date
    var mode = data.mode
    return mode === 'day' && vm.disabledDates.filter(function (dateToDisable) {
      return isSameDay(dateToDisable)(date)
    }).length
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.inputId) {
      vm.inputId = vm.inputId || 'date-picker-' + guid()
    }
    if (changesObj.ngModelOptions) {
      vm.ngModelOptions = vm.ngModelOptions || { updateOn: 'change blur' }
    }
    if (changesObj.minDate) {
      if (vm.dateOptions) {
        vm.dateOptions.minDate = vm.minDate
      }
    }
    if (changesObj.maxDate) {
      if (vm.dateOptions) {
        vm.dateOptions.maxDate = vm.maxDate
      }
    }
  }

  vm.onInputChange = function () {
    if (angular.isUndefined(vm.ngModel)) {
      vm.ngModel = null
    }
    if (vm.minDate && vm.ngModel && vm.ngModel < vm.minDate) {
      vm.ngModel = vm.minDate
    }
    if (vm.maxDate && vm.ngModel && vm.ngModel > vm.maxDate) {
      vm.ngModel = vm.maxDate
    }
    $timeout(function () {
      vm.onChanged()
    }, 0)
  }

  function guid () {
    function s4 () {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  }
}
